<template>
	<div v-if="showToast" @touchmove.prevent>
		<div class="toast-bg"></div>
		<div class="toast-bottom" v-if="showToast.position == 'bottom'">
			<div class="toast">
				<img class="toast-icon" :src="showToast.icon" v-if="showToast.icon" />
				<div class="toast-text">{{ showToast.message }}</div>
			</div>
		</div>
		<div class="toast-center" v-else>
			<div class="toast">
				<img class="toast-icon" :src="showToast.icon" v-if="showToast.icon" />
				<div class="toast-text">{{ showToast.message }}</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	/* showToast */
	.toast-bg {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 999999999999;
		background: transparent;
	}

	/* 水平居中必备样式 */
	.toast-center {
		position: fixed;
		z-index: 999999999999;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		text-align: center;
	}

	/* 底部10% */
	.toast-bottom {
		position: fixed;
		z-index: 10000;
		top: 0;
		bottom: 10%;
		left: 0;
		right: 0;
		text-align: center;
	}
	/* 底部10% */
	.toast-bottom::after {
		content: '';
		display: inline-block;
		width: 0;
		height: 100%;
	}

	.toast {
		display: inline-block;
		padding: 0.1rem 0.2rem;
		max-width: 2.6rem;
		font-size: 0.14rem;
		color: #fff;
		background: rgba(0, 0, 0, 0.7);
		border-radius: 0.05rem;
		text-align: center;
	}

	/* 垂直居中必备样式 */
	.toast-center::after {
		content: '';
		display: inline-block;
		width: 0;
		height: 100%;
		vertical-align: middle;
	}

	.toast-icon {
		display: block;
		margin: 0 auto 0.05rem;
		width: 0.5rem;
		height: 0.5rem;
	}
</style>
<script>
	export default {
		name: 'toast',
		data() {
			return {};
		},
		props: ['showToast'],
	};
</script>



// WEBPACK FOOTER //
// src/modules/toast.vue